// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1___6216dbd8097792088c9","cls2":"ConfirmationBanner-cls2__f2126d9f7ec6caccf674 ConfirmationBanner-cls1___6216dbd8097792088c9"};